import { parseMoney } from "@/lib/api";

/**
 * Desconto do balcão — a conta, num lugar só.
 *
 * O PDV tinha um campo solto de "Desconto R$". Três problemas, todos vistos no
 * balcão:
 *
 * 1. o lojista negocia em PORCENTAGEM ("faço 10% pra você") e digitava a conta
 *    de cabeça, errando em venda de valor quebrado;
 * 2. nada mostrava quanto o desconto representava, então R$ 200 numa venda de
 *    R$ 250 passava sem ninguém estranhar;
 * 3. o teto do perfil só era conferido pelo SERVIDOR, no clique de finalizar —
 *    ou seja, depois de montar o carrinho, vincular o cliente e digitar o
 *    pagamento. O vendedor descobria o limite na frente do cliente, com a venda
 *    pronta, e tinha de desmontar tudo.
 *
 * Guardar o TIPO junto do valor (e não converter tudo para reais na hora de
 * digitar) é o que faz "10%" continuar valendo 10% quando um item entra ou sai
 * do carrinho depois.
 */

/** Quanto o desconto vale em reais, dado o subtotal. Nunca passa do subtotal. */
export function discountAmount({ type, value, subtotal }) {
  const n = parseMoney(value);
  if (!(n > 0) || !(subtotal > 0)) return 0;
  const bruto = type === "percentual" ? (subtotal * Math.min(100, n)) / 100 : n;

  return Math.min(subtotal, Math.round(bruto * 100) / 100);
}

/** Quanto o desconto representa do subtotal, em %. É o número que o teto compara. */
export function discountPercent({ type, value, subtotal }) {
  if (!(subtotal > 0)) return 0;

  return Math.round((discountAmount({ type, value, subtotal }) / subtotal) * 10000) / 100;
}

/**
 * O desconto cabe no teto do perfil?
 *
 * `maxPercent` null/undefined = sem teto (admin, ou perfil que ninguém
 * configurou). A margem de 0,01 acompanha a do servidor: sem ela, um desconto de
 * exatamente 10% num subtotal quebrado pode virar 10,000001% no arredondamento e
 * ser recusado por nada.
 */
export function discountExceedsCap({ type, value, subtotal, maxPercent }) {
  if (maxPercent === null || maxPercent === undefined) return false;

  return discountPercent({ type, value, subtotal }) > Number(maxPercent) + 0.01;
}
